/**
 * WEARTH Recently viewed / pairing — no jQuery, no Slick, no ?view= fetch.
 * v2: optional VARIANT hero loop video inside fixed 4:5 tiles.
 */
(function () {
  "use strict";

  var STORAGE_KEY = "recently-viewed-products";
  var MAX_STORE = 12;

  function prefersReducedMotion() {
    try {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    } catch (e) {
      return false;
    }
  }

  function readCatalog(root) {
    var el = root.querySelector("[data-wearth-pairing-catalog]");
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || "[]");
    } catch (e) {
      return [];
    }
  }

  function readHistory() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function writeHistory(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(-MAX_STORE)));
    } catch (e) {}
  }

  function pushCurrent(handle) {
    if (!handle) return;
    var hist = readHistory().filter(function (h) {
      return h !== handle;
    });
    hist.push(handle);
    writeHistory(hist);
  }

  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i];
      a[i] = a[j];
      a[j] = t;
    }
    return a;
  }

  function pickTwo(catalog, current, history) {
    var byHandle = {};
    catalog.forEach(function (p) {
      byHandle[p.handle] = p;
    });

    var picks = [];
    var seen = {};
    if (current) seen[current] = true;

    var histRev = history.slice().reverse();
    for (var i = 0; i < histRev.length && picks.length < 2; i++) {
      var h = histRev[i];
      if (seen[h] || !byHandle[h]) continue;
      picks.push(byHandle[h]);
      seen[h] = true;
    }

    if (picks.length < 2) {
      var pool = shuffle(
        catalog.filter(function (p) {
          return !seen[p.handle];
        })
      );
      for (var j = 0; j < pool.length && picks.length < 2; j++) {
        picks.push(pool[j]);
        seen[pool[j].handle] = true;
      }
    }
    return picks;
  }

  function playPairingVideo(card, video) {
    if (!video) return;
    try {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    } catch (e) {}
  }

  function pausePairingVideo(video) {
    if (!video) return;
    try {
      video.pause();
    } catch (e) {}
  }

  function bindPairingVideo(card, video) {
    if (!video || video.getAttribute("data-wearth-pairing-bound") === "1") return;
    video.setAttribute("data-wearth-pairing-bound", "1");
    function markPlaying() {
      card.classList.add("wearth-pairing--video-playing");
    }
    function unmarkPlaying() {
      card.classList.remove("wearth-pairing--video-playing");
    }
    video.addEventListener("playing", markPlaying);
    video.addEventListener("loadeddata", markPlaying);
    video.addEventListener("pause", unmarkPlaying);
    video.addEventListener("emptied", unmarkPlaying);
  }

  function observePairingVideo(card, video) {
    if (typeof IntersectionObserver === "undefined") {
      playPairingVideo(card, video);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        var on = entries[0] && entries[0].isIntersecting;
        if (on) playPairingVideo(card, video);
        else pausePairingVideo(video);
      },
      { root: null, rootMargin: "48px 0px", threshold: 0.2 }
    );
    io.observe(card);
  }

  function renderCard(product) {
    var a = document.createElement("a");
    a.className = "wearth-pairing__card";
    a.href = product.url;
    a.setAttribute("aria-label", product.title);

    var media = document.createElement("div");
    media.className = "wearth-pairing__media";

    var img = document.createElement("img");
    img.className = "wearth-pairing__img";
    img.src = product.image;
    img.alt = product.title;
    img.loading = "lazy";
    img.width = 360;
    img.height = 450;
    media.appendChild(img);

    var videoUrl = product.video && String(product.video).trim();
    if (videoUrl && !prefersReducedMotion()) {
      var video = document.createElement("video");
      video.className = "wearth-pairing__video";
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute("muted", "");
      video.setAttribute("loop", "");
      video.setAttribute("playsinline", "");
      video.setAttribute("preload", "none");
      video.setAttribute("aria-hidden", "true");
      video.src = videoUrl;
      media.appendChild(video);
      a.setAttribute("data-wearth-pairing-has-video", "1");
      bindPairingVideo(a, video);
      observePairingVideo(a, video);
    }

    var meta = document.createElement("div");
    meta.className = "wearth-pairing__meta";
    var title = document.createElement("span");
    title.className = "wearth-pairing__name";
    title.textContent = product.title;
    var price = document.createElement("span");
    price.className = "wearth-pairing__price";
    price.textContent = product.price || "";
    meta.appendChild(title);
    if (product.price) meta.appendChild(price);

    a.appendChild(media);
    a.appendChild(meta);
    return a;
  }

  function initRoot(root) {
    if (!root || root.getAttribute("data-wearth-pairing-ready") === "1") return;
    root.setAttribute("data-wearth-pairing-ready", "1");

    var current = root.getAttribute("data-current-handle") || "";
    var catalog = readCatalog(root);
    if (!catalog.length) {
      root.style.display = "none";
      return;
    }

    if (current) pushCurrent(current);

    var history = readHistory();
    var items = pickTwo(catalog, current, history);
    if (!items.length) {
      root.style.display = "none";
      return;
    }

    var usedRecent =
      history.length > 0 &&
      items.some(function (p) {
        return history.indexOf(p.handle) >= 0;
      });

    var titleEl = root.querySelector("[data-wearth-pairing-title]");
    if (titleEl) {
      titleEl.textContent = usedRecent
        ? root.getAttribute("data-heading-recent") || "Recently viewed"
        : root.getAttribute("data-heading-fallback") || "You may also like";
    }

    var grid = root.querySelector("[data-wearth-pairing-grid]");
    if (!grid) return;
    grid.innerHTML = "";
    items.forEach(function (p) {
      grid.appendChild(renderCard(p));
    });
  }

  function boot() {
    document.querySelectorAll("[data-wearth-pairing]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
